import { localSlotIdOfThreadKey } from "@/lib/targeting/local-slots";
import { slotIdOfThreadKey } from "@/lib/targeting/slot-thread";
import type { WidgetRoute } from "@/lib/widget-route";

/** Where the visitor last was inside the Messages tab, with the page's top launcher slot at that time. */
export interface RememberedMessagesRoute {
  route: WidgetRoute;
  topSlotId: string | null;
}

/** The Messages routes worth remembering: the list or a real thread (not the resume placeholder). */
export function isRememberableMessagesRoute(route: WidgetRoute): boolean {
  return route.kind === "messages" || (route.kind === "messages-thread" && !route.pendingLatest);
}

/**
 * Re-entering the Messages tab (tab switch or the round launcher) restores the visitor's last position:
 * the list again, the same thread again. Exception: a `message:<slotId>` thread belongs to the page it
 * was opened on, so once the page's slot changed it is NOT restored (the caller falls back to the
 * resolver: the current page's slot thread). `null` = nothing to restore.
 */
export function resumeMessagesRoute(
  remembered: RememberedMessagesRoute | null,
  currentTopSlotId: string | null,
): WidgetRoute | null {
  if (!remembered) return null;
  const { route } = remembered;
  if (
    route.kind === "messages-thread" &&
    (slotIdOfThreadKey(route.threadKey) || localSlotIdOfThreadKey(route.threadKey))
  ) {
    if (remembered.topSlotId !== currentTopSlotId) return null;
  }
  return route;
}
